import React from 'react'

import { IconClose } from 'components/Zui/Icon'
import { ScrollableDirective } from 'components/Zui'
function Privacy({ onClose }) {
    return (
        <>
            <div className="settings-wrapper">
                <div className="setting-header-wrapper">
                    <div className="setting-header-title">
                        <span>Privacy Policy</span>
                    </div>
                    <div className="close-setting-wrapper" onClick={onClose}>
                        <div className="user-settings-close-button">
                            <IconClose size="m" className="close-setting-icon" />
                        </div>
                    </div>
                </div>
                <div className="legal-details-wrapper">
                    <ScrollableDirective style={{ maxHeight: '100%' }}>
                        <div className="legal-content-wrapper">
                            <div className="legal-content-container">
                                <div className="content-heading">
                                    <span>Privacy statement</span>
                                </div>
                                <div className="company-title">
                                    <span>ZEISS Surgical Cloud</span>
                                </div>
                                <div className="legal-content">
                                    <div>
                                        By the provisions of the General Data Processing Regulation
                                        (GDPR), this Privacy policy statement informs you of how
                                        your personal data are collected, processed, and outlines
                                        your data privacy rights concerning Zeiss Surgical Cloud1.0.
                                    </div>{' '}
                                    <div>
                                        {' '}
                                        This privacy policy statement only covers the users of Zeiss
                                        Surgical Cloud1.0 and their data, but not the processed
                                        patient data.
                                    </div>
                                    <div>
                                        Responsibility Carl Zeiss Meditec AG (ZEISS) provides the
                                        Zeiss Surgical Cloud1.0 by order of its customers as a data
                                        processor and will thereby only process the data for the
                                        following purposes.
                                    </div>
                                </div>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>Purpose</span>
                                </div>
                                <ul type="1">
                                    <li>
                                        Zeiss Surgical Cloud1.0 is a browser-based, cloud-based
                                        surgical software application intended to display and share
                                        patient, diagnostic images, and pdf data generated by the
                                        Zeiss Visualization Systems by trained healthcare
                                        professionals.
                                    </li>
                                    <li>
                                        Displayed surgical images and videos are intended to support
                                        doctors’ assessment of patients, as well as to help
                                        healthcare professionals share the patient’s data with other
                                        professionals of the community using sharing functionalities
                                        available in the Zeiss Surgical Cloud1.0 software.
                                    </li>
                                    <li>
                                        In addition, Zeiss Surgical Cloud1.0 will help doctors to
                                        access and share patient clinical data remotely, outside of
                                        the practice environment.
                                    </li>
                                    <li>
                                        Zeiss Surgical Cloud1.0 uses ZEISS ID as an authentication
                                        service. The user data is processed to enable compliant
                                        access control.
                                    </li>
                                </ul>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>Data categories</span>
                                </div>
                                <ul>
                                    <li>
                                        The following personal user data are stored and processed by
                                        ZEISS on behalf of ZEISS’ customers (hospital, clinic, etc.)
                                        to fulfill the purposes mentioned above:
                                        <ul>
                                            <li>
                                                Personal master data (e.g. last name, first name)
                                            </li>
                                            <li>Registration data (e.g. username, password)</li>
                                            <li>Contact data (e.g. email, IP address)</li>
                                            <li>Communication data (e.g. chat data)</li>
                                            <li>
                                                Specific user data (e.g. login status/login,
                                                documentation of uploads and downloads, reports)
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        The following personal user data are stored and processed by
                                        ZEISS within the feedback functionality for ZEISS own
                                        purposes:
                                        <ul>
                                            <li>Contact data (e.g. email, IP address)</li>
                                            <li>Specific user data (e.g. user feedback)</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>Legal basis</span>
                                </div>
                                <ul type="1">
                                    <li>
                                        When using Zeiss Surgical Cloud1.0, the user data is
                                        processed that the functions described above can be carried
                                        out and the doctor in question can fulfill his obligation
                                        arising from the employment relationship with the
                                        responsible clinic or the treatment contract with the
                                        patient.
                                    </li>
                                    <li>
                                        The legal basis for this processing is therefore usually
                                        art. 6 par. 1 sent. 1 b) GDPR in conjunction with § 26 par.
                                        1 FDPA and art. 9 par. 2 h) and par. 3 in conjunction with
                                        art. 6 par. 1 sent. 1 b) GDPR.
                                    </li>
                                    <li>
                                        About the collected feedback data, the two different
                                        purposes have to be distinguished:
                                        <ul>
                                            <li>
                                                General user feedback data will be processed to
                                                answer the user’s request appropriately. The legal
                                                basis for this processing is art. 6 par. 1 sent. 1
                                                a) GDPR.
                                            </li>
                                            <li>
                                                User feedback data that turns out to be a complaint
                                                has to be stored due to post-market surveillance
                                                purposes. The legal basis for this processing is
                                                art. 6 par. 1 sent. 1 c) GDPR in conjunction with
                                                art. 10 par. 8 and art. 83 of the Medical Device
                                                Regulation (EU) 2017/745.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Duration of data storage the user data that are processed
                                        within Zeiss Surgical Cloud1.0 will be deleted after the
                                        related customer quits its contract with ZEISS.
                                    </li>
                                    <li>
                                        General user feedback data will be kept person related for 6
                                        months and then anonymized.
                                    </li>
                                    <li>
                                        Complaint feedback data will be stored person related for at
                                        least 15 years, whereas the following deletion procedure is
                                        not feasible due to the possibility of regressing claims of
                                        patients suffering long-term damage
                                    </li>
                                    <li>
                                        About logfiles, your data will be kept as long as we are
                                        legally obliged to and subsequently deleted.
                                    </li>
                                </ul>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>Use of cookies</span>
                                </div>
                                <div className="license-content" style={{ marginLeft: '25px' }}>
                                    <span>General information</span>
                                </div>
                                <ul type="1">
                                    <li>
                                        ZEISS online services use cookies, pixels, and other similar
                                        technologies (collectively called "cookies" from now on) to
                                        recognize your browser or device, learn more about your
                                        interests, and provide you with essential functions and
                                        services as well as for other purposes.
                                    </li>
                                    <li>
                                        Cookies are files that are sent to your browser and
                                        installed in the device from which you browse to store
                                        information that can be retrieved later.
                                    </li>
                                    <li>
                                        Cookies have the advantage that they enable you to use many
                                        of our offerings (services/features). If you do not allow
                                        cookies to be placed or reject cookies in any way, it is not
                                        possible, for example, to use various aspects of our online
                                        services or to use other products or services that require
                                        cookies.
                                    </li>
                                    <li>
                                        Approved third-party providers may also place cookies when
                                        you interact with ZEISS services. Third-party providers
                                        include search engines, measurement and analysis service
                                        providers, social media networks, and advertising companies.
                                    </li>
                                    <li>
                                        Third parties use cookies to provide content, including ads,
                                        that is relevant to your interests, to measure the
                                        effectiveness of their ads, and to provide services on
                                        behalf of ZEISS.
                                    </li>
                                    <li>
                                        You can find information about the transfers to third
                                        countries outside the EU that, if applicable, are made by
                                        the third parties identified in this statement in their
                                        corresponding policies. In certain cases, the data collected
                                        can be used to identify the visitor. The data collected is
                                        used to improve the offering or target customers. IP
                                        addresses are generally shortened or only processed in an
                                        anonymous form.
                                    </li>
                                    <li>
                                        Depending on their function and purpose, cookies can be
                                        grouped into different categories: strictly necessary
                                        cookies, functional cookies, performance or analytical
                                        cookies, cookies for marketing purposes, and social media
                                        cookies
                                    </li>
                                    <li>
                                        Essential cookies are necessary to allow you to navigate
                                        through a website and use the features built into it.
                                        Without these cookies, the website's functionality cannot be
                                        guaranteed. This means that certain actions performed by the
                                        user (e.g., text input, configuration options) are not
                                        stored as the user navigates to other pages on the website.
                                    </li>
                                    <li>
                                        Performance cookies are used to gather data on how you are
                                        interacting with the website, to provide a better user
                                        experience (e.g., personalizing the functionality of the
                                        website). Performance cookies do not collect identifiable
                                        information about you, meaning that the data collected via
                                        performance cookies is anonymized and used to improve
                                        website functions, which means that your use of other
                                        websites cannot be used to track.
                                    </li>
                                    <li>
                                        If you want to modify, limit, or object to the use of
                                        cookies or the analysis of your surfing behavior, or if you
                                        wish to withdraw your objection, you can change and manage
                                        the settings for each website in most standard browsers as
                                        follows:
                                        <ul>
                                            <li>
                                                Chrome: Click the padlock icon next to the address
                                                bar (on SSL-certified pages) or on the information
                                                icon (i).
                                            </li>
                                            <li>
                                                Firefox: Click the icon next to the web address.
                                                Look to the right of the check box and select
                                                "Further information". The cookie management is
                                                located under "Privacy &#38; Security".
                                            </li>
                                            <li>
                                                Internet Explorer: Click the gear icon, then go to
                                                "Extras" &#62; "Internet Options". Go to the
                                                "Privacy" tab. The cookie management options are
                                                located under "Advanced". You can also manage
                                                browser cookies for the most common web browsers via
                                                the browser settings.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        The help function of most web browsers explains how to
                                        prevent your browser from accepting new cookies, how your
                                        browser can notify you when you receive a new cookie, how to
                                        disable cookies and when the cookies expire. If you
                                        deactivate all cookies in your browser, neither ZEISS nor
                                        third parties will transmit cookies to your browser.
                                        However, if you do this, you may need to manually adjust
                                        some settings each time you visit a website, and some
                                        features and services may not work. You can also manage your
                                        cookies by clicking on the cookie’s configuration link at
                                        the footer of the website.
                                    </li>
                                </ul>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>Performance cookie</span>
                                </div>
                                <ul type="1">
                                    <ul>
                                        <li>Matomo We use Matomo as performance cookies.</li>
                                        <li>
                                            Matomo is deactivated when you visit our website. Only
                                            if you actively agree, your usage behavior will be
                                            recorded anonymously.
                                        </li>
                                        <li>
                                            You can opt out of the use of Matomo cookies every time.
                                            As with every cookie technology Matomo stores text files
                                            on your computer, which enables ZEISS to analyze and
                                            evaluate the usage behavior.
                                        </li>
                                        <li>
                                            ZEISS uses the information to undertake research and
                                            diagnostics to improve content, products, and services
                                            as well as to improve the Zeiss Surgical Cloud1.0
                                            platform and adjust it to suit your likely interests.
                                        </li>
                                        <li>
                                            Your IP address will be anonymized immediately; this
                                            means that you as a user remain anonymous.
                                        </li>

                                        <li>
                                            The information generated by the cookie about your use
                                            of this website is not passed on to third parties. To
                                            learn more, see Matomo’s Privacy Policy, where you can
                                            also opt-out of website tracking.
                                        </li>
                                    </ul>
                                    <li>
                                        Additionally, you can find information about the data
                                        retention period for each cookie that you allow to be
                                        installed on your computer in the cookies’ display tools of
                                        your browser.
                                    </li>
                                </ul>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>Your rights</span>
                                </div>
                                <ul type="1">
                                    <li>
                                        The GDPR provides you with an array of options concerning
                                        the self-determination of processing of your data. For
                                        example, you have the following rights:
                                        <ul>
                                            <li>the right to information under Art. 15 GDPR,</li>
                                            <li>right to correction under Art. 16 GDPR,</li>
                                            <li>right to erasure under Art. 17 GDPR,</li>
                                            <li>
                                                right to restriction of processing under Art. 18
                                                GDPR,
                                            </li>
                                            <li>right of notification under Art. 19 GDPR,</li>
                                            <li>
                                                right to data portability under Art. 20 GDPR, and
                                            </li>
                                            <li>where applicable right to object Art. 21 GDPR.</li>
                                        </ul>
                                    </li>
                                    <li>
                                        If you believe that your data is processed unlawfully or it
                                        has failed to address your complaints adequately, you have
                                        the right under Art. 77 GDPR to complain with a responsible
                                        data protection authority.
                                    </li>
                                    <li>
                                        Contact If you have any questions about Zeiss Surgical
                                        Cloud1.0 or want to assert one of your rights mentioned
                                        above, please contact the responsible clinic/hospital as a
                                        data controller.
                                    </li>
                                    <li>
                                        For further information on ZEISS data privacy guidelines
                                        please refer to https://www.zeiss.com/dataprotection.
                                        Changes and amendments to this Privacy policy statement If
                                        any substantial changes are made to the type and method of
                                        processing your data, we will inform you of these changes in
                                        good time. Version: 1.0
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ScrollableDirective>
                </div>
            </div>
        </>
    )
}

export default Privacy
